import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=6fb19629&"
import script from "./VInput.vue?vue&type=script&lang=js&"
export * from "./VInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports